const buzonsugerencias = state => state.buzonsugerencias;

export default {
  buzonsugerencias,
};